import React from 'react';
import firebase from 'firebase/app';
import 'firebase/firestore';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';

var listaunidadest=[];


export default function  ParadaMap (props) {
    const [statelista, setalista]=React.useState([{
    }]);
const [statecampi,setstatecampi]=React.useState('');
const [unidadet,setaunidadet]=React.useState([{
}]);
React.useEffect (()=>{
    pegalista();
    async function pegalista(){
        firebase.firestore().collection("unidadetransporte").where('status', '==', true).where('campi', '==', props.campi)
         .get()
         .then(function(querySnapshot) {
             listaunidadest=[];
             querySnapshot.forEach(function(doc) {
                 listaunidadest.push({id: doc.id, label: doc.data().nomeunidadetransporte});
             })
             setalista(listaunidadest)
             console.log("lista unidade transporte: ", listaunidadest);
         })
         .catch(function(error) {
             console.log("erro carregar as unidades de transporte: ", error);
             alert('Não foi Possível carregar as unidades de transporte.');
         })
 
         }

},[props])


    React.useEffect (()=>{
       
        setstatecampi(props.campi);
        console.log("valor requirid unidtransporte  ", props.campi);
        setaunidadet(props.unidadet);
        
        
    

        
            },[statecampi,unidadet,props])


            console.log ("valor campi valendo nesno", unidadet);

   /*React.useEffect(() => {
        console.log("entrou no pega lista unidade t")
        
            
        
        
    },[stat])*/
         
        
        
        

        

   

    const handleuniade=(event, value)=>(
        
        props.setaunidadetransporte(value),
        console.log("target ", value)
    )

    return(
        <Autocomplete onChange={handleuniade}
                    //value={unidadet}
                    id="combounidadetchef"
                    options={statelista}
                    disabled={props.disabled}
                    getOptionLabel={(option) => option.label}
                    //getOptionSelected={(option) => option=== unidadet}
                    defaultValue={props.unidadet}
                    renderInput={(params) => <TextField {...params}  required={props.requer}  label="Unidade de Transporte" variant="outlined" />}
                />
                
)
}